<template>
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
  >
    <path d="M5.99715 0C7.4366 0 8.66324 1.01028 8.94113 2.4021C8.99519 2.6729 8.8195 2.93626 8.5487 2.99032C8.2779 3.04439 8.01455 2.86869 7.96048 2.5979C7.77578 1.67278 6.95891 1 5.99715 1C4.94166 1 4.07694 1.81675 4.00051 2.85271L3.99502 3.00213L3.995 5H10C11.1046 5 12 5.89543 12 7V14C12 15.1046 11.1046 16 10 16H2C0.89543 16 0 15.1046 0 14V7C0 5.89543 0.89543 5 2 5H2.995L2.99502 3.00213C2.99502 1.3441 4.33912 0 5.99715 0ZM10 6H2C1.44772 6 1 6.44772 1 7V14C1 14.5523 1.44772 15 2 15H10C10.5523 15 11 14.5523 11 14V7C11 6.44772 10.5523 6 10 6ZM6 9.5C6.55228 9.5 7 9.94772 7 10.5C7 11.0523 6.55228 11.5 6 11.5C5.44772 11.5 5 11.0523 5 10.5C5 9.94772 5.44772 9.5 6 9.5Z" />
  </svg>
</template>
